import React from 'react';
import './emptyState.css';

export const EmptyState = ({ icon = 'sparkles', title, message, action }) => (
    <div className="course-library-empty" data-testid="course-library-empty-state">
        <i className={`fa fa-${icon} course-library-empty-icon`} />
        <h3 className="course-library-empty-title">{title}</h3>
        {message && <p className="course-library-empty-message">{message}</p>}
        {action && <div className="course-library-empty-action">{action}</div>}
    </div>
);

export default EmptyState;
